import { useOptionalOgpCompanyTypeContext } from 'ogp/providers/ogp-company-type-provider';

export const useHideLimitedCompanyShiftFields = (): boolean => {
  const companyTypeContext = useOptionalOgpCompanyTypeContext();
  return companyTypeContext?.isLimitedCompany ?? false;
};
